import { useState, useEffect } from "react";
import "./WazKBToolbar.css";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { KB_MENUS, selectCurrentCollectionId, selectEditingCollection, selectUIStates, setUIStates } from "../../../redux/features/appData";
import "../../../ds2/components/SidebarMenu.css";

type WazKBToolbarProps = {

}

export const WazKBToolbar = ({} : WazKBToolbarProps) => {

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const uiStates = useSelector(selectUIStates)
    const collectionId = useSelector(selectEditingCollection)?.id

    const getSelectedItemClassName = (menu: string) => {
        if (uiStates.kbSelectedMenu === menu) {
            return "ds2-sidebar-item ds2-sidebar-item-selected";
        }
        return "ds2-sidebar-item";
    }
    
    // console.log("[WazKBToolbar] collectionId: ", collectionId);
    // console.log("[WazKBToolbar] uiStates.kbSelectedMenu: ", uiStates.kbSelectedMenu);

    return (
        <div className="ds2-sidebar">
            <div className="ds2-sidebar-section">
                Knowledge Base
            </div>

            <div 
                key={KB_MENUS.ACTIVITY}
                className={getSelectedItemClassName(KB_MENUS.ACTIVITY)}
                onClick={() => {
                    dispatch(setUIStates({...uiStates, kbSelectedMenu: KB_MENUS.ACTIVITY}));
                    navigate("/waz/kb/activity")
                
                }}
            >
                Activity
            </div>

            <div 
                key={KB_MENUS.ADD}
                className={getSelectedItemClassName(KB_MENUS.ADD)}
                onClick={() => {
                    dispatch(setUIStates({...uiStates, kbSelectedMenu: KB_MENUS.ADD}));
                    navigate("/waz/kb/add")
                }}
            >
                Add Resources
            </div>

            <div 
                key={KB_MENUS.MANAGE}
                className={getSelectedItemClassName(KB_MENUS.MANAGE)}
                onClick={() => {
                    dispatch(setUIStates({...uiStates, kbSelectedMenu: KB_MENUS.MANAGE}));
                    navigate("/waz/kb/manage/")
                }}
            >
                Manage Resources
            </div>

            <div 
                key={KB_MENUS.PERSONAS}
                className={getSelectedItemClassName(KB_MENUS.PERSONAS)}
                onClick={() => {
                    dispatch(setUIStates({...uiStates, kbSelectedMenu: KB_MENUS.PERSONAS}));
                    navigate("/waz/kb/personas/")
                }}
            >
                Personas
            </div>

            <div 
                key={KB_MENUS.ANALYTICS}
                className={getSelectedItemClassName(KB_MENUS.ANALYTICS)}
                onClick={() => {
                    dispatch(setUIStates({...uiStates, kbSelectedMenu: KB_MENUS.ANALYTICS}));
                    navigate("/waz/kb/analytics/")
                }}
            >
                Analytics
            </div>

            {/* <div className="waz-kb-toolbar-section">
                Documents
            </div> */}

            {/* <div 
                className="waz-kb-toolbar-item"
                onClick={() => {
                    dispatch(setUIStates({...uiStates, kbSelectedMenu: KB_MENUS.DOCUMENTS}));
                    navigate("/waz/kb/documents");
                }}
            >
                Documents
            </div> */}
           
        </div>
    )
}